import { memo } from "react";

const ChatComposerDisclaimer = ({ t, isCompact }) => (
  <span
    className={`text-text-subtle text-center select-none block ${
      isCompact ? "text-[10px]" : "text-[11px]"
    }`}
  >
    {t("chat.disclaimer")}
  </span>
);

export default memo(ChatComposerDisclaimer);
